import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {gameUiTexts} from 'data/ui-texts';
import apiHelper from 'helpers/api-helper';
import Button from 'components/ui/button/button';
import Popup from 'components/ui/popup/popup';
import './change-thoughts-group.scss';

const ChangeThoughtsGroup = ({partIndex, minigameData, gameId, minigameGameData, handleGoToNextPart}) => {

	const [isLoading, setIsLoading] = useState(false);
	const [showIntroPopup, setShowIntroPopup] = useState(true);
	const [showInfoPopup, setShowInfoPopup] = useState(false);
	const [textInput, setTextInput] = useState('');


	/**
	 * Handle input
	 * @param {obj} event 
	 */
	const handleInput = (event) => {
		let value = event.target.value;
		setTextInput(value);
	};

	/**
	 * Submit input
	 * @returns 
	 */
	const submitInput = () => {
		if (!textInput || textInput.length === 0 || isLoading) return; 

		setIsLoading(true);
		apiHelper('group/submit-minigame-input', {
			gameId: gameId,
			minigameType: minigameData.parts[partIndex].type,
			minigameId: minigameData.id,
			value: textInput
		}).then(
			(response)=>{
				if (response.status === 'success') {
					setTextInput('');
				} else {
					console.error(response);
				}
				setIsLoading(false);
			},
			(error) => {
				console.error(error);
				setIsLoading(false);
			}
		);
	};

	return (
		<div className="ChangeThoughtsGroup">
			<div className="ChangeThoughtsGroup-wrap">
				<div className="ChangeThoughtsGroup-title">
					<span>{minigameData.parts[partIndex].titleGroup}</span>
				</div>
				<div className="ChangeThoughtsGroup-text">
					<span>{minigameData.parts[partIndex].textGroup}</span>
				</div>
				<div className="ChangeThoughtsGroup-options">
					{minigameData.parts[partIndex].options.map((option, index) => {
						return (
							<div key={index} className='ChangeThoughtsGroup-option'>
								<span >{option}</span>
							</div>
						);
					})
					}
				</div>
			</div>
			<textarea 
				className="ChangeThoughtsGroup-textarea"
				placeholder={minigameData.parts[partIndex].placeholder}
				value={textInput ? textInput : ''}
				onChange={(event)=>{handleInput(event);}}
			/>
			<div className="ChangeThoughtsGroup-button">
				<Button 
					isLoading={isLoading}
					classes={['red']}
					text={minigameData.parts[partIndex].submitBtnText} 
					onClick={() => {submitInput();}} 
				/>
			</div>

			{/* Info popup button */}
			{minigameData.parts[partIndex].infoPopupText &&
				<div className="ChangeThoughtsGroup-infoBtn">
					<Button classes={['info']} onClick={() => {setShowInfoPopup(true);}} />
				</div>
			}


			{/* Info popup */}
			{showInfoPopup &&
				<Popup
					type={'intro'}
					text={minigameData.parts[partIndex].infoPopupText} 
					buttons={[
						{text: gameUiTexts.ok, action: setShowInfoPopup, parameters: [false]}
					]}
				/>
			}

			{/* Intro popup */}
			{showIntroPopup && 
				<Popup 
					type={'intro'}
					text={minigameData.parts[partIndex].introPopupText } 
					buttons={[
						{text: gameUiTexts.ok, action: setShowIntroPopup, parameters: [false]}
					]}
				/>
			}
		</div>
	);
};

ChangeThoughtsGroup.propTypes = {
	partIndex: PropTypes.number.isRequired,
	minigameData: PropTypes.object.isRequired,
	gameId: PropTypes.string.isRequired,
	minigameGameData: PropTypes.object,
	handleGoToNextPart: PropTypes.func.isRequired
};

export default ChangeThoughtsGroup;
